import { useModal } from '@ebay/nice-modal-react';
import { Wand } from 'lucide-react';
import { useParams } from 'react-router-dom';
import Loading from '@/components/Loading';
import Section from '@/components/Section';
import useCampaign from '@/hooks/useCampaign';
import PromptBuilder from '../PromptBuilder/PromptBuilder';
import { Button } from '../ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';

const Campaign = () => {
  const { campaignId } = useParams();
  const campaign = useCampaign(campaignId as string, {
    refetchInterval: 3000,
  });
  const drawer = useModal('campaign-drawer');

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-4">
        <h2 className="text-lg font-bold">Manage Campaign</h2>
        <Button
          onClick={() => {
            drawer.show({ campaign: campaign?.data });
          }}
        >
          Edit
        </Button>
      </div>

      {/* Loading State */}
      {campaign.isLoading ? (
        <Section>
          <Loading />
        </Section>
      ) : (
        <Section title={campaign?.data?.name}>
          <Tabs defaultValue="overview" className="w-full">
            <TabsList className="grid grid-cols-4">
              <TabsTrigger value="overview">Overview</TabsTrigger>
              <TabsTrigger value="taskPrompt">
                <Wand size={20} className="mr-2" />
                Task Prompt
              </TabsTrigger>
              <TabsTrigger value="summaryPrompt">
                <Wand size={20} className="mr-2" />
                Summary Prompt
              </TabsTrigger>
              <TabsTrigger value="analysisPrompt">
                <Wand size={20} className="mr-2" />
                Analysis Prompt
              </TabsTrigger>
            </TabsList>
            <TabsContent value="overview">
              <div className="mt-4">
                <p className="font-semibold">Campaign Name:</p>
                <p>{campaign?.data?.name}</p>
              </div>
              <div className="mt-4">
                <p className="font-semibold">Description:</p>
                <p>{campaign?.data?.description}</p>
              </div>
              <div className="mt-4">
                <p className="font-semibold whitespace-pre-wrap">Task:</p>
                <p>{campaign?.data?.task}</p>
              </div>
              <div className="mt-4">
                <p className="font-semibold whitespace-pre-wrap">Pathway ID:</p>
                <p>{campaign?.data?.pathway_id}</p>
              </div>
            </TabsContent>
            <TabsContent value="taskPrompt">
              <PromptBuilder type={'task_prompt'} campaign={campaign?.data} />
            </TabsContent>
            <TabsContent value="summaryPrompt">
              <PromptBuilder type={'summary_prompt'} campaign={campaign?.data} />
            </TabsContent>
            <TabsContent value="analysisPrompt">
              <PromptBuilder type={'analysis_prompt'} campaign={campaign?.data} />
            </TabsContent>
          </Tabs>
        </Section>
      )}
    </div>
  );
};

export default Campaign;
